import { put, takeEvery } from "redux-saga/effects";
import { PLATFORM_ADMIN_TENANT_ONBOARD_REQUEST, SERVER_ERROR_MESSAGE } from "../constants/constants";
import { PLATFORM_ADMIN_TENANT_ONBOARD_URL } from "../constants/constants";
import {
  PlatformAdminTenantOnboardFail,
  PlatformAdminTenantOnboardSuccess,
} from "../actions/platformAdminTenantOnBoardAction";
import { getAxiosHeaders, getService } from "../../library/RestAPI";
import { SET_NTFS_SNACKBAR_MESSAGE } from "../../components/views/TenantSignUp/tenantSignUpConstants";

function* PlatformAdminTenantOnboard(action) {
  let options;
  yield console.log("Hello from TenantSignUpSaga");
  try {
    const formData = new FormData();
    const payload = JSON.stringify(action.payload.tenantDetails);
    const logo = action.payload.image ? action.payload.image : "";
    formData.append("payload", payload);
    formData.append("logo", logo);
    options = {
      method: "POST",
      url: PLATFORM_ADMIN_TENANT_ONBOARD_URL,
      headers: getAxiosHeaders(true, "multipart/form-data"),
      data: formData,
    };
    try {
      const res = yield getService(options);
      if (res && res.status === 201) {
        yield put(PlatformAdminTenantOnboardSuccess());
        yield put({ type: "TRACK_TRAVERSAL", payload: "Tenant Management" });
        yield action.payload.history.push("/platform/tenantManagement");
      } else {
        let errorMessage = res.response.data.errorMessage || SERVER_ERROR_MESSAGE;
        yield put ({type: SET_NTFS_SNACKBAR_MESSAGE, payload: errorMessage});
        yield put(PlatformAdminTenantOnboardFail(errorMessage));
      }
    } catch (e) {
      yield put(PlatformAdminTenantOnboardFail(e.message ? e.message : ""));
      yield put ({type: SET_NTFS_SNACKBAR_MESSAGE, payload: SERVER_ERROR_MESSAGE});
    }
  } catch (e) {
    yield put(PlatformAdminTenantOnboardFail(e.message ? e.message : ""));
    yield put ({type: SET_NTFS_SNACKBAR_MESSAGE, payload: SERVER_ERROR_MESSAGE});
  }
}

function* PlatformAdminTenantOnboardSaga() {
  yield takeEvery(
    PLATFORM_ADMIN_TENANT_ONBOARD_REQUEST,
    PlatformAdminTenantOnboard
  );
}

export default PlatformAdminTenantOnboardSaga;